import { Component } from '@angular/core';

@Component({
  selector: 'ui-bottom-actions',
  templateUrl: './bottom-actions.component.html',
  styleUrls: ['./bottom-actions.component.scss'],
})
export class BottomActionsComponent {}
